import { render, staticRenderFns } from "./YandexMap.vue?vue&type=template&id=28347c4c"
import script from "./YandexMap.vue?vue&type=script&lang=ts"
export * from "./YandexMap.vue?vue&type=script&lang=ts"
import style0 from "./YandexMap.vue?vue&type=style&index=0&id=28347c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports